/* Riposte — pastilles de coloris sur vignette.
   Chaque vignette est autonome : on ne cherche jamais une image ailleurs
   que dans le conteneur qui porte les pastilles cliquées. */
(function () {
  'use strict';

  document.querySelectorAll('[data-rp-swap]').forEach(function (tile) {
    // image_tag de Liquid refuse les attributs à tirets : on cible donc
    // l'image par sa classe, avec un attribut optionnel en surcharge.
    var img = tile.querySelector('[data-rp-swap-img]') || tile.querySelector('img');
    var cta = tile.querySelector('[data-rp-swap-cta]');
    var dots = Array.prototype.slice.call(tile.querySelectorAll('[data-rp-dot]'));
    if (!img || dots.length < 2) return;

    // L'URL de départ sert de base : on ne concatène jamais deux fois
    // un paramètre de variante sur un lien déjà modifié.
    var baseHref = cta ? cta.getAttribute('href').split('?')[0] : null;

    function select(btn) {
      dots.forEach(function (d) {
        var on = d === btn;
        d.classList.toggle('rp-dot--on', on);
        d.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var src = btn.getAttribute('data-img');
      if (src) {
        var srcset = btn.getAttribute('data-srcset');
        // srcset d'abord : sinon le navigateur affiche brièvement l'ancienne
        // image en attendant de réévaluer le jeu de sources.
        if (srcset) { img.setAttribute('srcset', srcset); } else { img.removeAttribute('srcset'); }
        img.setAttribute('src', src);
      }

      var vid = btn.getAttribute('data-variant');
      if (cta && baseHref && vid) cta.setAttribute('href', baseHref + '?variant=' + vid);
    }

    dots.forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn); });
    });
  });
})();
